import React, { useEffect, useState } from 'react';
import Heading from '../../component/Heading/Heading';
import logo from "../../assets/icons/logo.svg"
import AuthBg from '../../component/auth/AuthBg';
import { verifyEmail } from '../../services/authenticationService';
import { useNavigate, useParams } from 'react-router';
import Toast from '../../component/toastify/Index';
import { checkTokenAndNavigate } from '../../utils/js/expireInvitation';
import "../../styles/pages/auth/signUp.scss"
import "../../styles/pages/auth/backtoDashboard.scss"
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const BackToDashboard = () => {
    const { email, token } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const checkEmailverify = async () => {
        const response = await verifyEmail(email, token)
        if (response?.isSuccess) {
            Toast(response?.message, 'success');
        }
    }

    const handleNavigate = () => {
        localStorage.setItem("authToken", JSON.stringify(token))
        navigate("/dashboard");
    }

    useEffect(() => {
        const isTokenNotExpire = checkTokenAndNavigate(token, navigate);
        if (isTokenNotExpire) {
            checkEmailverify()
        }
    }, [token])

    return (
        <div className="auth send-otp" >
            <div className="signup-container">
                <Grid container>
                    <Grid item size={{ xs: 12, md: 6, lg: 4 }} className='min-vh-100'>
                        <div className="logo-container">
                            <img src={logo} alt="logo" className='company-logo' />
                        </div>

                        <div className="signup-data">
                            <div className="input-container">
                                <div className='send-otp-data'>
                                    <Heading text={t("common_text_email_verified_successfully")} />
                                    <p className='not-recieve-email'>{t("common_text_go_to")} <span className='dark-blue resend' onClick={handleNavigate}>{t("module_dashboard")}</span></p>
                                </div>
                            </div>
                        </div>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6, lg: 8 }} className="signup-img-padding">
                        <AuthBg />
                    </Grid>
                </Grid>
            </div>
        </div >
    );
}

export default BackToDashboard;
